import { motion } from "framer-motion";

const AboutJivi = () => {
      const cardVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  
    return (
        <div style={{ background: "#fff", overflow: "hidden" }}>
        
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          style={{
            fontFamily: "Epilogue",
            fontWeight: "700",
            fontSize: "38px",
            marginTop: "10px",
            textAlign: "center",
            lineHeight: "1.3",
          }}
        >
          About JIVI Solutions
        </motion.div>

       
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          style={{
            fontFamily: "Epilogue",
            fontSize: "14px",
            fontWeight: "400",
            marginTop: "25px",
            textAlign: "center",
          }}
        >
          Innovating workforce productivity through intelligent technology
        </motion.div>

        
        <div
          style={{
            padding: "40px 20px",
            fontFamily: "Epilogue",
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center",
          }}
        >
        
          <motion.div
            custom={0}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            whileHover={{ scale: 1.03 }}
            viewport={{ once: true }}
            style={{
              backgroundColor: "#E2FFFC",
              flex: "1 1 45%",
              minWidth: "300px",
              borderRadius: "30px",
              padding: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "20px",
                fontWeight: "700",
                color: "#1E1E1E",
              }}
            >
              Intelligent Workforce Technology
            </div>

            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "15px",
                fontWeight: "400",
                color: "#3B3B3B",
                lineHeight: "1.6",
                textAlign: "start",
              }}
            >
              Our flagship platform, JIVIEWS, is an end-to-end Workforce Management
              System engineered for complex, high-performance environments—offering
              scheduling, workload planning, automated allocation, time & attendance,
              payroll integration, and real-time reporting.
            </div>
          </motion.div>

       
          <motion.div
            custom={1}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            whileHover={{ scale: 1.03 }}
            viewport={{ once: true }}
            style={{
              backgroundColor: "#FFDFE5",
              flex: "1 1 45%",
              minWidth: "300px",
              borderRadius: "30px",
              padding: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "20px",
                fontWeight: "700",
                color: "#1E1E1E",
              }}
            >
              Global Impact & Innovation
            </div>

            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "15px",
                fontWeight: "400",
                color: "#3B3B3B",
                lineHeight: "1.6",
                textAlign: "start",
              }}
            >
              JIVI Solutions partners with leading global terminals and supports
              15,000+ workforce users worldwide, with strong presence across Malaysia,
              India, Netherlands and expanding international regions.
            </div>
          </motion.div>

         
          <motion.div
            custom={2}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            whileHover={{ scale: 1.03 }}
            viewport={{ once: true }}
            style={{
              backgroundColor: "#FFF4DF",
              flex: "1 1 90%",
              minWidth: "300px",
              borderRadius: "30px",
              padding: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "20px",
                fontWeight: "700",
                color: "#1E1E1E",
              }}
            >
              Commitment to Excellence
            </div>

            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "15px",
                fontWeight: "400",
                color: "#3B3B3B",
                lineHeight: "1.6",
                textAlign: "start",
              }}
            >
              We believe in long-term collaboration and continuous innovation,
              empowering organizations with real-time insights, increased transparency,
              and improved employee engagement.
            </div>
          </motion.div>
        </div>
      </div>
    );
};

export default AboutJivi;